import React from "react";
import abedalslam from "../../Images/abedalslam.png";
import waze from "../../Images/waze.png";
import call from "../../Images/call.png";
import whatsapp from "../../Images/whatsapp.png";
import { useAppContext } from "../../AppContext";
import { useParams } from "react-router-dom";

export default function MPHomeFirstBlock() {
  const { AllData, WazeData } = useAppContext();
  const { BarberPhoneNumber } = useParams();
  const screenHeight = window.screen.height;

  const handleWaze = () => {
    const lat = WazeData?.lat;
    const lng = WazeData?.long;

    if (!lat || !lng) {
      alert("Location not available");
      return;
    }
    const url = `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
    window.location.href = url;
  };

  const handleCall = () => {
    window.location.href = `tel:${AllData.barberData.countryNumber}${AllData.barberData.phoneNumber}`;
  };

  const handleWhatsApp = () => {
    window.open(
      `https://wa.me/${AllData.barberData.countryNumber}${AllData.barberData.phoneNumber}`,
      "_blank"
    );
  };

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        width: "100%",
        minHeight: screenHeight / 2.2,
        alignItems: "center",
        justifyContent: "center",
        borderBottomLeftRadius: "32px",
        borderBottomRightRadius: "32px",
        flexDirection: "column",
        overflow: "hidden",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        paddingBottom: "40px",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at 30% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)",
          zIndex: 0,
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
          padding: "0 20px",
        }}
      >
        <div
          style={{
            position: "relative",
            padding: "4px",
            background: "linear-gradient(135deg, #fff 0%, #f0f0f0 100%)",
            borderRadius: "24px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
          }}
        >
          <img
            src={AllData.barberData.image}
            alt="Barber"
            style={{
              width: "120px",
              height: "120px",
              borderRadius: "20px",
              objectFit: "cover",
            }}
          />
        </div>

        <div
          style={{
            textAlign: "center",
            color: "#fff",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "700",
              margin: "0 0 4px 0",
              textShadow: "0 2px 4px rgba(0,0,0,0.2)",
            }}
          >
            {AllData.barberData.name}
          </h2>
          <p
            style={{
              fontSize: "15px",
              margin: 0,
              opacity: 0.95,
              fontWeight: "400",
            }}
          >
            {AllData.barberData.countryNumber} {AllData.barberData.phoneNumber}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            gap: "16px",
            marginTop: "8px",
          }}
        >
          {[
            { icon: waze, onClick: handleWaze, label: "Navigate" },
            { icon: call, onClick: handleCall, label: "Call" },
            { icon: whatsapp, onClick: handleWhatsApp, label: "WhatsApp" },
          ].map((action, index) => (
            <button
              key={index}
              onClick={action.onClick}
              style={{
                width: "56px",
                height: "56px",
                backgroundColor: "#fff",
                border: "none",
                borderRadius: "16px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                transition: "all 0.3s ease",
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = "scale(0.95)";
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              <img
                src={action.icon}
                alt={action.label}
                style={{ width: "32px", height: "32px" }}
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
